import React, { useState, useEffect } from 'react';
import Typography from '@mui/material/Typography';
import LeiaMais from '../LeiaMaisBox';
import CardInfoParques from '../CardInfoParques';
import ListaFotosParque from '../ListaFotosParque/ListaFotosParque';
import { Divider } from '@mui/material';
import Fade from '@mui/material/Fade';
import Skeleton from '@mui/material/Skeleton';
import MensagemErro from '../MensagemErro';
import { Link } from 'react-router-dom';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import { BrowserRouter as Router, useParams } from "react-router-dom";
import BannerParque from '../BannerParque';
import './estilo.css';

const DetalhesParque = ({setParqueSelecionado}) => {
    const { ulrDoParque } = useParams();
    const [parque, setParque] = useState([]);
    const [erroServidor, setErroServidor] = useState(false);
    const [estaCarregado, setEstaCarregado] = useState(false);
    
    if (localStorage.getItem('avisoCovid') === null) {
        localStorage.setItem('avisoCovid', true);
    } 
    
    useEffect(() => {
        window.scroll(0, 0);
        setParqueSelecionado(true)
        const opcoes = {
            headers: {
                'Content-Type': 'application/json'
            },
            method: 'GET'
        }

        fetch(`${process.env.REACT_APP_API_URL}/parque/${ulrDoParque}`, opcoes)
            .then(resposta => resposta.json())
            .then(dados => {
                setParque(dados.data);
                setEstaCarregado(true);
                setErroServidor(false);
            })
            .catch(erro => {
                // TODO: exibir a mensagem de erro ao invés do console.log(`Erro --> ${erro}`);
                // talvez seja interessante usar o erro como parametro no setErroServidor
                setEstaCarregado(true);
                setErroServidor(true);
            });
    }, [ulrDoParque, setEstaCarregado, setParqueSelecionado]);

    const Conteudo = () => {
        if (estaCarregado && !erroServidor) {
            if(parque) {
                return(
                    <Fade in={estaCarregado} timeout={750} >
                        <div>
                            <div className="info-parques">
                                <div className="container-web">
                                    <div>
                                        <Link to="/">
                                            <ArrowBackIosIcon color="action" sx={{ fontSize: 30, width: "45px", marginBottom: "-4px", '&:hover': { fontSize: 32 } }}/>
                                        </Link>
                                    </div>
                                    <div>
                                        <Typography gutterBottom variant="h5" component="div">
                                            {parque.titulo}
                                        </Typography>
                                        <a href={parque.mapa} className="link-endereco" target="_blank" rel="noopener noreferrer">{parque.endereco}</a>
                                    </div>
                                </div>
                                <div className="info-parques-container">
                                    <ListaFotosParque parque={parque}/>
                                    <div className="container-mobile">
                                        <div style={{marginBottom: "20px", marginTop: "17px"}}>
                                            <Typography gutterBottom variant="h5" component="div">
                                                {parque.titulo}
                                            </Typography>
                                            <a href={parque.mapa} className="link-endereco" target="_blank" rel="noopener noreferrer">{parque.endereco}</a>
                                        </div>
                                        <Divider className="divider" style={{marginBottom: "-18px !important"}}/>
                                    </div>
                                    <div className="flexColumn">
                                        <div className="corpoInfo">
                                            <div>
                                                <CardInfoParques parque={parque}/>
                                                <Divider className="divider container-mobile"/>
                                            </div>
                                            <div style={{width: "100%"}}>
                                                {parque.banner ?
                                                    <section className="partInfra banner" style={{marginBottom: "20px"}}>
                                                        <BannerParque ulrBanner={parque.banner} altTxt={parque.banner_txt}/>
                                                    </section>
                                                    :
                                                    <Typography gutterBottom variant="h5" component="div" style={{marginTop: "20px", textAlign: "center"}}>
                                                        <span>{parque.banner_txt}</span>
                                                    </Typography>
                                                }
                                                {parque.plano_diretor &&
                                                    <section className="partInfra plano_diretor" style={{marginBottom: "20px"}}>
                                                        <Typography gutterBottom variant="h6" component="div">
                                                            Plano Diretor
                                                        </Typography>
                                                        <LeiaMais texto={parque.plano_diretor} linhas={3}/>
                                                    </section>
                                                }
                                                {parque.plano_diretor && <Divider className="divider" style={{maxWidth: "800px"}}/>}
                                                {parque.particularidades &&
                                                    <section className="partInfra particularidades" style={{marginBottom: "20px", marginTop: parque.plano_diretor ? "0px": "36px"}}>
                                                        {parque.tipo === "Natural" ? 
                                                            <Typography gutterBottom variant="h6" component="div">
                                                                Biodiversidade
                                                            </Typography>
                                                        : 
                                                            <Typography gutterBottom variant="h6" component="div">
                                                                    Particularidades
                                                            </Typography>
                                                        }
                                                        <LeiaMais texto={parque.particularidades} linhas={4}/>
                                                    </section>
                                                }
                                                <Divider className="divider" style={{maxWidth: "800px"}}/>
                                                {parque.infraestrutura &&
                                                    <section className="partInfra" style={{marginBottom: "20px"}}>
                                                        {parque.tipo === "Natural" ? 
                                                            <Typography gutterBottom variant="h6" component="div">
                                                                Caracterização
                                                            </Typography>
                                                        : 
                                                            <Typography gutterBottom variant="h6" component="div">
                                                                Infraestrutura
                                                            </Typography>
                                                        }
                                                        <LeiaMais texto={parque.infraestrutura} linhas={2}/>
                                                        {/* <Divider className="divider container-mobile"/> */}
                                                    </section>
                                                }
                                                {parque.bairro &&
                                                    <div>
                                                        <Divider className="divider" style={{maxWidth: "800px"}}/>
                                                        <section className="partInfra bairro" style={{marginBottom: "20px"}}>
                                                            <Typography gutterBottom variant="h6" component="div">
                                                                O Bairro
                                                            </Typography>
                                                            <LeiaMais texto={parque.bairro} linhas={3}/>
                                                            {/* <Divider className="divider container-mobile"/> */}
                                                        </section>
                                                    </div>
                                                }
                                                {parque.quem_foi != null &&
                                                <div>
                                                    <Divider className="divider" style={{maxWidth: "800px"}}/>
                                                    <section className="partInfra quem_foi" style={{marginBottom: "20px"}}>
                                                        <Typography gutterBottom variant="h6" component="div">
                                                            Quem foi {parque.nome_quem_foi}
                                                        </Typography>
                                                        <LeiaMais texto={parque.quem_foi} linhas={3}/>
                                                        {/* <Divider className="divider container-mobile"/> */}
                                                    </section>
                                                </div>
                                                }
                                                {parque.topicos_extras.map(info => (
                                                    info.local == 'topicos' &&
                                                    <div key={info.id}>
                                                        <Divider className="divider" style={{maxWidth: "800px"}}/>
                                                        <section className="partInfra topicos_extras" style={{marginBottom: "20px"}}>                                                            
                                                            <Typography gutterBottom variant="h6" component="div">
                                                                {info.titulo_topico}
                                                            </Typography>
                                                            {info.tipo == 'link' ?
                                                            <a href={info.url_topico} style={{marginTop: "7px", fontWeight: "400"}} target="_blank" rel="noopener noreferrer">{info.texto_topico}</a>
                                                            :
                                                            <LeiaMais texto={info.texto_topico} linhas={3}/>
                                                            }
                                                        </section>
                                                    </div>
                                                ))}
                                                <Divider className="divider" style={{maxWidth: "800px"}}/>
                                                {parque.tx_conselho_gestor ?
                                                    <section className="partInfra conselho_gestor" style={{marginBottom: "20px"}}>
                                                        <Typography gutterBottom variant="h6" component="div">
                                                            Conselho Gestor
                                                        </Typography>
                                                        {/* <LeiaMais texto={parque.tx_conselho_gestor} linhas={3}/> */}
                                                        <p style={{marginTop: "0", fontWeight: "400", textAlign: "left", marginBottom: "0"}} dangerouslySetInnerHTML={{__html: parque.tx_conselho_gestor}}></p>
                                                        <Divider className="divider container-mobile"/>
                                                    </section> :
                                                    <section className="partInfra conselho_gestor" style={{marginBottom: "20px"}}>
                                                        <Typography gutterBottom variant="h6" component="div">
                                                            Conselho Gestor
                                                        </Typography>
                                                        {/* <LeiaMais texto={parque.tx_conselho_gestor} linhas={3}/> */}
                                                        <p>
                                                            Os Conselhos Gestores dos Parques Municipais foram criados em 2003 para garantir a participação popular no planejamento, gerenciamento e fiscalização das atividades que ocorrem nos parques. O objetivo é envolver a comunidade na discussão das políticas públicas de forma consultiva, com enfoque nas questões socioambientais. Os Conselhos são integrados por representantes da sociedade civil (em geral, três frequentadores e um representante de movimento social ou entidade local), um representante dos trabalhadores do parque e três representantes do Poder Executivo. <br />
                                                            Saiba mais sobre os Conselhos Gestores no <a href="https://prefeitura.sp.gov.br/web/meio_ambiente/w/parques/conselhos_gestores/40498">site da SVMA</a>.
                                                            <br /> <br />
                                                            {/* <a href="https://www.prefeitura.sp.gov.br/cidade/secretarias/upload/DECRETO%20N%C2%B035_537%20DE%2029%20DE%20SETEMBRO%20DE%201995.pdf">CONSULTE AQUI O REGULAMENTO DO PARQUE.</a> */}
                                                            {/* <br /> <br /> */}
                                                            <a href="https://legislacao.prefeitura.sp.gov.br/leis/portaria-secretaria-municipal-do-verde-e-do-meio-ambiente-svma-38-de-21-de-maio-de-2024/detalhe">Portaria Secretaria Municipal do Verde e do Meio Ambiente - SVMA Nº 38 de 21 de Maio de 2024</a><br />
                                                            Medidas preventivas frente aos eventos climáticos extremos nos Parques Naturais Municipais e Parques Urbanos Municipais.
                                                        </p>
                                                        <Divider className="divider container-mobile"/>
                                                    </section>
                                                }
                                            </div>
                                        </div>
                                        <section>
                                            <Typography gutterBottom variant="h6" component="div">
                                                Localização
                                            </Typography>
                                            <div className="loadingGif">
                                                <iframe src={parque.iframe_src} className="mapaIframe" title="Mapa com a localização do parque"></iframe>
                                            </div>
                                        </section>                         
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Fade>
                )
            }else {
                return (
                    <MensagemErro tipo="resultado" />
                )
            }
        } else if (erroServidor){
            return (
                <MensagemErro tipo="servidor" />
            );
        } else {
            var skeletons = [];
            for (var i = 0; i < 1; i++) {
                skeletons.push(
                    <div key={i}>
                        <Skeleton animation="wave" variant="rectangular" width={'100%'} height={200} sx={{ borderRadius: '4px' }} />
                        <Skeleton animation="wave" variant="rectangular" width={'60%'} height={'1.75rem'} sx={{ margin: '1.5rem 0 0.8rem 1rem', borderRadius: '4px' }} />
                        <Skeleton animation="wave" variant="rectangular" width={'40%'} height={'1rem'} sx={{ margin: '0.5rem 0 0 1rem', borderRadius: '4px' }} />
                        <Skeleton animation="wave" variant="rectangular" width={'75%'} height={'1rem'} sx={{ margin: '0.5rem 0 0 1rem', borderRadius: '4px' }} />
                        <Skeleton animation="wave" variant="rectangular" width={'60%'} height={'1rem'} sx={{ margin: '0.5rem 0 0 1rem', borderRadius: '4px' }} />
                    </div>
                );
            }
            return (
                <div className="skeleton">
                    {skeletons}
                </div>
            );
        } 
    }

    return (
        <Conteudo />
    );
    
}
export default DetalhesParque;
